export const REGISTER_ID = {
    UNREGISTER: 'b1f157ca195e11ed8bf4fa163e89e3c8', // ยังไม่ได้ลงทะเบียนความเสี่ยง
    IN_PROGRESS: 'd8e0b40e195e11ed8bf4fa163e89e3c8', //อยู่ระหว่างการลงทะเบียน
    REGISTERED: 'd95dab9d195e11ed8bf4fa163e89e3c8', //ลงทะเบียนความเสี่ยงแล้ว
};